export const APP_AUTHOR_NAME_FULL = 'Florian CASSAGNE'

export const APP_DEFAULT_LANGUAGE = 'en'